import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DEFAULT_PAGING } from 'src/app/@shared/constants/site.constants';
import { ListViewState } from '../models/list-ui-state.model';

@Injectable()

export class ListViewStateService {

    private defaultListViewState: ListViewState = {
        pageIndex: DEFAULT_PAGING.pageIndex,
        pageSize: DEFAULT_PAGING.pageSize,
        viewMode: 'CARDS',
        variantViewMode: 'compressed',
        scrollPosition: 0,
        filters: {},
        sort: { active: 'PageNumber', direction: 'asc', },
        selectedRecords: [],
        includeExpiredEvents: false
    };

    private listViewStateSubject = new BehaviorSubject<ListViewState>(this.defaultListViewState);
    listViewState$ = this.listViewStateSubject.asObservable();

    get listViewStateValue(): ListViewState {
        return this.listViewStateSubject.value;
    }

    updateListViewState(partial: Partial<ListViewState>) {
        const updated = { ...this.listViewStateSubject.value, ...partial };
        this.listViewStateSubject.next(updated);
    }

    resetListViewState() {
        this.listViewStateSubject.next(this.defaultListViewState);
    }

    toggleSelection(record: any, idKey: string = 'id') {
        const current = [...this.listViewStateValue.selectedRecords];
        const index = current.findIndex(item => item?.[idKey] === record?.[idKey]);

        if (index > -1) {
            current.splice(index, 1);
        } else {
            current.push(record);
        }

        this.updateListViewState({ selectedRecords: current });
    }

    isSelected(id: string, idKey: string = 'id'): boolean {
        return this.listViewStateValue.selectedRecords.some(record => record?.[idKey] === id);
    }

    clearSelection() {
        this.updateListViewState({ selectedRecords: [] });
    }
}
